import { type StripePaymentElementChangeEvent } from "@stripe/stripe-js";
import { type Dispatch, type SetStateAction, useState } from "react";

export const useStripeFormState = (): [
  StripePaymentElementChangeEvent | undefined,
  Dispatch<SetStateAction<StripePaymentElementChangeEvent | undefined>>,
] => {
  return useState<StripePaymentElementChangeEvent | undefined>(undefined);
};
